import React, { useState } from 'react';
import { Question } from '../../types/models';
import { Button } from '../common/Button';
import { Input } from '../common/Input';
import { testSetService } from '../../services/testSetService';
import { TestSet } from '../../types/models';

type CreateTestSetFormProps = {
  availableQuestions: Question[];
  onSetCreated: (newSet: TestSet) => void;
};

export const CreateTestSetForm = ({ availableQuestions, onSetCreated }: CreateTestSetFormProps) => {
  const [setName, setSetName] = useState('');
  const [selectedQuestionIds, setSelectedQuestionIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheckboxChange = (questionId: string) => {
    setSelectedQuestionIds(prevSelected =>
      prevSelected.includes(questionId)
        ? prevSelected.filter(id => id !== questionId) // Odznacz
        : [...prevSelected, questionId] // Zaznacz
    );
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (selectedQuestionIds.length === 0) {
      setError('Musisz wybrać co najmniej jedno pytanie.');
      return;
    }
    setError('');
    setIsLoading(true);

    try {
      const newSet = await testSetService.createTestSet(setName, selectedQuestionIds);
      onSetCreated(newSet); // Przekaż nowo utworzony zestaw do komponentu nadrzędnego

      // Reset formularza
      setSetName('');
      setSelectedQuestionIds([]);
    } catch (err) {
      setError('Nie udało się utworzyć zestawu.');
    } finally {
      setIsLoading(false);
    }
  };

  

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '2rem', borderTop: '2px solid #ccc', paddingTop: '2rem' }}>
      <h3>Stwórz nowy zestaw testowy</h3>
      <Input
        id="set-name"
        label="Nazwa zestawu"
        value={setName}
        onChange={(e) => setSetName(e.target.value)}
        required
      />

      <h4>Wybierz pytania do zestawu:</h4>
      {availableQuestions.length === 0 ? (
        <p>Brak dostępnych pytań. Najpierw dodaj jakieś pytania powyżej.</p>
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', padding: '1rem' }}>
          {availableQuestions.map(q => (
            <div key={q.id}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedQuestionIds.includes(q.id)}
                  onChange={() => handleCheckboxChange(q.id)}
                />
                {q.text}
              </label>
            </div>
          ))}
        </div>
      )}
      
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      <Button type="submit" disabled={isLoading || availableQuestions.length === 0} style={{ marginTop: '1rem' }}>
        {isLoading ? 'Tworzenie...' : 'Stwórz zestaw'}
      </Button>
    </form>
  );
};